var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ backgroundImage: 'url(' + _vm.src + ')' }),attrs:{"alt":""},on:{"click":function($event){return _vm.$modal.show('photo-details', {
    fromEvents: true,
    id: _vm.photoId,
    eventArr: _vm.extra,
    isVideo: _vm.isVideo || false
})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }